'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiWorld = function TiWorld(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 3.3c-8.3 0-15 6.7-15 15s6.7 15 15 15 15-6.7 15-15-6.7-15-15-15z m3.3 3.4c0 1.6-0.8 3.3-2.5 3.3s-2.5 1.7-2.5 3.3v5s1.7 0 1.7-5c0-0.9 0.7-1.6 1.7-1.6s1.6 0.7 1.6 1.6v5c-0.9 0-1.6 0.8-1.6 1.7s0.7 1.7 1.6 1.7c1 0 1.7-0.8 1.7-1.7h1.7v-3.3l1.6 1.6-1.6 1.7c0 5 0 5-3.4 6.7 0-1.7-1.6-1.7-5-1.7v-3.3l-3.3-3.4v-3.3c-1.7 0-1.7 1.7-1.7 1.7l-4.9-4.9c0.2-0.4 0.4-0.7 0.6-1l0.9-1.1c2.4-2.9 6-4.7 10.1-4.7 1.2 0 2.3 0.2 3.3 0.4v1.3z' })
        )
    );
};

exports.default = TiWorld;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/world.js
// module id = 4048
// module chunks = 0